import { Body, breakpoints, Spacer } from '@spritz-finance/ui'
import styled from 'styled-components'
import { useScreenSize } from '../../../../context/useScreenSize'
import { FullPopularBillFragment } from '../../../../graphql/generated/graphql'
import { InstitutionImage } from '../InstitutionImage'
import { useLinkBillContext } from './LinkBill'
import { BillTypeWrapper } from './SelectBillType'

const Container = styled.div`
    width: 100%;
`

const BillsRow = styled.div`
    display: grid;
    column-gap: 20px;
    row-gap: 20px;
    grid-template-columns: 1fr 1fr 1fr;

    ${breakpoints.xsmall} {
        grid-template-columns: 1fr 1fr;
    }
`

export const PopularBills = () => {
    const { isDesktop } = useScreenSize()
    const { popularBills, addAccountForMerchant } = useLinkBillContext()

    const handleAddAccount = (bill: FullPopularBillFragment) => {
        addAccountForMerchant({
            id: bill.institution.institutionId,
            name: bill.institution.name,
            parentName: bill.institution.name,
            logo: bill.institution.logoUrl,
            account: bill.name,
            types: [],
        })
    }

    if (!isDesktop) return null

    return (
        <Container>
            <BillsRow>
                {popularBills.slice(0, 6).map((bill) => (
                    <BillTypeWrapper key={bill.id} onClick={() => handleAddAccount(bill)}>
                        <InstitutionImage institution={bill.institution} />
                        <Spacer height={8} />
                        <Body.SmBold align="center">{bill.name}</Body.SmBold>
                    </BillTypeWrapper>
                ))}
            </BillsRow>
        </Container>
    )
}
